import { Component } from "react";
import { ExclamationTriangleFill } from "react-bootstrap-icons";
import i18n from "../i18n";
import { recordError } from "../instrumentation";

// Last line of defense: the fallback must never throw itself, so translation
// errors (backend not loaded yet, i18n init failed) degrade to English.
function translate(key, fallback) {
  try {
    return i18n.t(key, { defaultValue: fallback }) || fallback;
  } catch {
    return fallback;
  }
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    recordError(error, {
      "error.type": "react_render",
      "error.component_stack": info.componentStack?.slice(0, 500) ?? "",
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="d-flex flex-column justify-content-center align-items-center text-center min-vh-100 bg-light px-3">
            <ExclamationTriangleFill
              size={56}
              className="mb-4"
              style={{ color: "#ffeb00", filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.25))" }}
            />
            <h2 className="fw-bold mb-2">
              {translate("errorBoundary.title", "Something went wrong.")}
            </h2>
            <p className="text-muted mb-4" style={{ maxWidth: "30rem" }}>
              {translate(
                "errorBoundary.description",
                "An unexpected error occurred. You can try again, or reload the page if the problem persists."
              )}
            </p>
            <div className="d-flex gap-2">
              <button
                type="button"
                className="btn fw-bold px-4"
                style={{ background: "#ffeb00", color: "#000000" }}
                onClick={() => this.setState({ hasError: false })}
              >
                {translate("errorBoundary.tryAgain", "Try again")}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary px-4"
                onClick={() => window.location.reload()}
              >
                {translate("errorBoundary.reload", "Reload page")}
              </button>
            </div>
          </div>
        )
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
